import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorService } from './error.service';
import { EnvironmentsEnum } from '../../../environments/environments.enum';
import { environment } from '../../../environments/environment';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  private _errorService: ErrorService;

  constructor(injector: Injector) {
    setTimeout(() => (this._errorService = injector.get(ErrorService)));
  }

  handleError(error) {
    if (environment.env !== EnvironmentsEnum.production) {
      console.error(error);
    }

    if (this._errorService) {
      // TODO: figure out autocomplete
      if (error.message && error.message.indexOf('refresh') < 0) {
        this._errorService.alertSystem(error);
      }
    }
  }
}
